import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DasSenseHDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "das-sense-dashboard" */ '../../pages/dassenseH-dashboard'
    ),
);

const dasSenseHDashboardRouter = (
  <Route path="das-sense-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="das-sense-dashboard"
            component={<DasSenseHDashboardComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dasSenseHDashboardRouter;
